import { bannersImports } from "./bannersImports.js";

export const banners = {
  booking: {
    wroclaw: {
      pl: [bannersImports.price[20].pl],
      eng: [bannersImports.price[20].eng],
      de: [bannersImports.price[20].de],
    },
    katowice: {
      pl: [bannersImports.summer.pl, bannersImports.studia30.pl],
      eng: [bannersImports.summer.eng, bannersImports.studia30.eng],
      de: [bannersImports.summer.de, bannersImports.studia30.de],
    },
    "warszawa-box": {
      pl: [bannersImports.pixelBox.pl, bannersImports.price[20].pl],
      eng: [bannersImports.pixelBox.eng, bannersImports.price[20].eng],
      de: [bannersImports.pixelBox.de, bannersImports.price[20].de],
    },
    gdansk: {
      pl: [bannersImports.studentpxl.pl],
      eng: [bannersImports.studentpxl.eng],
      de: [bannersImports.studentpxl.de],
    },
    poznan: {
      pl: [bannersImports.studentpxl.pl],
      eng: [bannersImports.studentpxl.eng],
      de: [bannersImports.studentpxl.de],
    },
  },
  price: bannersImports.price,
  voucher: bannersImports.voucher,
  pixelBox: bannersImports.pixelBox,
  seasonal: bannersImports.seasonal,
};
